import { useParams } from "react-router-dom";

import { useAssessmentQuery, useWorkGroupQuery } from "@/generated/graphql";

import { GroupCard } from "./group-card";
import { GroupCharterCard } from "./group-charter-card";
import * as styles from "./home-page.css";
import { InstructionCard } from "./instruction-card";

export function Preparation() {
  const { assessmentId = "" } = useParams();
  const { data: assessmentData } = useAssessmentQuery({
    variables: { assessmentId },
  });
  const { data: workGroupData } = useWorkGroupQuery({
    variables: { assessmentId },
  });

  const assessment = assessmentData?.assessment;
  const workGroup = workGroupData?.studentWorkGroup;
  const group = workGroup?.group;

  if (!assessment) {
    return null;
  }

  // Charter card only shows once the charter is usable (enabled AND a published
  // form exists), folded server-side into `groupCharterAvailable`.
  const showCharter = assessment.settings?.groupCharterAvailable ?? false;
  return (
    <>
      <div className={styles.verticalLine} />
      <GroupCard
        assessment={assessment}
        workGroupId={workGroup?.id}
        userGroup={group ?? null}
        finalised={workGroup?.finalised ?? false}
        changeRequested={workGroup?.latestGroupChangeRequest}
      />
      {group && showCharter && (
        <GroupCharterCard
          groupId={group.id}
          charter={workGroup?.charter}
          finalised={workGroup?.finalised}
          dueDate={assessment.settings?.groupCharterDueDate}
        />
      )}
      <InstructionCard
        assessment={assessment}
        groupWorkSettings={workGroup?.work?.settings}
        individualWorkSettings={workGroup?.individualWork?.settings}
      />
    </>
  );
}
